interface ChangelogEntry {
  version: string
  changes: string[]
}

const changelog: ChangelogEntry[] = [
  {
    version: "v6.6.2",
    changes: [
      "🐞 Prevent browser page translation from crashing the app",
    ],
  },
  {
    version: "v6.6.1",
    changes: [
      "🐞 Require a check-in group before advancing past the first step of check-in creation",
    ],
  },
  {
    version: "v6.6.0",
    changes: [
      "🛠️ Performance improvements for faster, smoother navigation",
      "🐞 Fixed status indicators that could occasionally get stuck",
      "🛠️ Behind-the-scenes cleanup and maintenance",
    ],
  },
  {
    version: "v6.5.2",
    changes: [
      "🐞 Paginate challenges, news and surveys lists in team edit page",
    ],
  },
  {
    version: "v6.5.1",
    changes: ["🛠️ Disable PostHog in dev environment"],
  },
  {
    version: "v6.5.0",
    changes: ["✨ Added PostHog analytics"],
  },
  {
    version: "v6.4.0",
    changes: [
      '✨ \"Client Survey\" flag for Surveys to skip the completion popup for surveys owned by the client',
    ],
  },
  {
    version: "v6.3.0",
    changes: [
      '✨ \"Dashboard Min Members\" field for Teams to define the minimum number of members required to display data in Dashboard',
    ],
  },
  {
    version: "v6.2.0",
    changes: ['✨ "Allow Support" flag for Teams'],
  },
  {
    version: "v6.1.1",
    changes: [
      "✨ Journey dates visible inside Team Journeys list",
      "🐞 Fixed Journey live visualization when a draft version exists",
    ],
  },
  {
    version: "v6.1.0",
    changes: ["🛠️ Vite migration"],
  },
  {
    version: "v6.0.3",
    changes: ["🛠️ Fixed Apollo Client fetch policy"],
  },
  {
    version: "v6.0.2",
    changes: ["🐞 Fixed Media upload", "🛠️ Improved old code"],
  },
  {
    version: "v6.0.1",
    changes: [
      "🐞 Fixed Template details page error",
      "🐞 Fixed Journey edit page error",
      "🛠️ Improved old code",
    ],
  },
  {
    version: "v6.0.0",
    changes: ["🛠️ Updated some project dependencies"],
  },
  {
    version: "v5.15.7",
    changes: [
      "✨ Removed start and end dates from Check-ins — they now inherit the time interval from their Check-in Group",
    ],
  },
  {
    version: "v5.15.6",
    changes: ["✨ Added Changelog"],
  },
  {
    version: "v5.15.5",
    changes: ["✨ Added Check-in Groups duplication"],
  },
]

export default changelog
